import { GenericError, User } from '@tendercuts/models';
import { ActionTryFail } from '.';
import {
  ActionSaveUser
} from './user-actions';
import { ActionLoadUser } from '@store/user/user-actions';
import { Actions, Effect } from '@ngrx/effects';
import { AppState } from '../state';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { ofAction } from 'ngrx-actions';
import {
  PubSubService,
  StorageService
} from '@tendercuts/providers';
import { Store } from '@ngrx/store';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private storage: StorageService,
    private events: PubSubService,
    public store: Store<AppState>
  ) {}

  @Effect()
  loadUser = this.actions$.pipe(
    ofAction(ActionLoadUser),
    switchMap(data => {
      return this.storage.getData(data.payload, User).pipe(
        map((user: User) => {
          if (user && user.isValid && user.isPosUser) {
            this.events.$pub('user:userLoaded', user);
            return new ActionSaveUser(user);
          }
          return new ActionTryFail(new GenericError('No user in cache'));
        })
      ); // return
    })
  );

}
